/** Runtime configuration, sourced from Vite env vars (see .env.example). */
export const config = {
  /** API base URL; empty string = same origin (the Worker serves both SPA and API). */
  apiBase: import.meta.env.VITE_API_BASE ?? '',
  tenantId: import.meta.env.VITE_ENTRA_TENANT_ID,
  clientId: import.meta.env.VITE_ENTRA_CLIENT_ID,
  apiScope: import.meta.env.VITE_ENTRA_API_SCOPE,
};
